module.exports = __webpack_public_path__ + "static/media/status.32023013.svg";